import React from 'react'
import img_1 from '../../../assets/images/home/RED SMALL BANNER.png'
import img_2 from '../../../assets/images/home/SILVER SMALL BANNER.png'
import img_3 from '../../../assets/images/home/LARGER MID SECTION BANNER.png'
import videoIcon from '../../../assets/images/coolicon.png'
import Slide from 'component/common/Slider'
import LeftArray from 'assets/images/leftArrow.png'
import RightArray from 'assets/images/rightArrow.png'
import vd from 'assets/images/DACE_PROMO_final.mp4'
import topevd from 'assets/images/tope.mp4'
import { Player } from 'video-react'

function slideFun(arr = []) {
  return arr.map((x, index) => {
    return (
      <div className='col-12 py-2' key={index}>
        <div className='position-absolute w-100 d-flex align-items-center justify-content-center h-100'>
          <div className='w-100 text-center'>
            <h1 className='text-light'>{x.content}</h1>
            <button
              className='btn btn-outline-light px-4 py-2'
              onClick={() => window.location.assign('/category')}
            >
              Shop Now
            </button>
          </div>
        </div>
        <img src={`/slide/${x.img}`} alt='' className='h-100 w-100' />
      </div>
    )
  })
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        backgroundImage: `url(${RightArray})`,
        backgroundRepeat: 'no-repeat',
        display: 'none',
        content: 'none',
      }}
      onClick={onClick}
    />
  )
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        backgroundImage: `url(${LeftArray})`,
        backgroundRepeat: 'no-repeat',
        display: 'none',
        content: 'none',
      }}
      onClick={onClick}
    />
  )
}
let settings = {
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: '30px',
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
}

function imgBlocks(props) {
  // console.log(props.play, 'pppppppppppppp')
  return (
    <div id='imgBlocks' className='pb-md-5 pb-2'>
      <div className='col-sm-6 py-2 d-none '>
        <div className='position-absolute w-100 d-flex align-items-center justify-content-center h-100'>
          <div className='w-100 text-center'>
            <h1 className='text-light'>Metal Cooking Pans</h1>
            <button className='btn btn-outline-light px-4 py-2'>Shop Now</button>
          </div>
        </div>
        <img src={img_2} alt='' className='h-100 w-100' />
      </div>
      <div className='col-sm-6 py-2 d-none '>
        <div className='position-absolute w-100 d-flex align-items-center justify-content-center h-100'>
          <div className='w-100 text-center'>
            <h1 className='text-light'>Metal Cooking Pans</h1>
            <button className='btn btn-outline-light px-4 py-2'>Shop Now</button>
          </div>
        </div>
        <img src={img_1} alt='' className='h-100 w-100' />
      </div>
      <span className='d-block h-100 w-100 d-sm-none'>
        <Slide slideData={slideFun(props.slideData)} settings={settings} />
      </span>
      {/* {!props?.play ? (<div className="col-12 my-sm-5 my-3 px-0">
        <div className="position-absolute w-100 d-flex align-items-center justify-content-center h-100">
          <div className="w-100 text-center">
            <h1 className="text-light col-11 col-sm-12 p-0">
              Appliance based cookery tips from Venkesh Butt
            </h1>
            <span className="text-light cursor-pointer" onClick={() => props.setPlay(!props?.play)}>
              <img src={videoIcon} /> Watch Video
            </span>

          </div>
        </div>
        <img src={img_3} className="w-100 d-md-none d-block img-responsive" style={{ height: "200px", borderRadius: "5px" }} alt="" />
        <img src={img_3} className="w-100 d-md-block d-none img-responsive" alt="" />

      </div>) : (
        <Player
          playsInline={true}
          poster={img_3}
          src={vd}
        />)} */}

      <div className='row'>
        <div className='col-lg-6 col-md-6 col-sm-12 my-2'>
          <Player height={200} playsInline={true} poster={img_3} src={vd} />
        </div>

        {/* <div className="mt-3 pt-3" /> */}
        <div className='col-lg-6 col-md-6 col-sm-12 my-2'>
          <Player height={200} playsInline={true} poster='' src={topevd} />
        </div>
      </div>
    </div>
  )
}

export const ImgBlocks = imgBlocks
